import { FormattedMessage } from 'react-intl';

import { Button, ButtonVariant } from '@jsmdg/yoshi';
import { trackLoadMoreButtonClicked } from './loadMoreButton.tracking';

type LoadMoreButtonProps = {
    readonly onClick: () => void;
    readonly disabled: boolean;
};

const LoadMoreButton = ({ disabled = false, onClick }: LoadMoreButtonProps): JSX.Element => {
    const handleLoadMoreClick = async (): Promise<void> => {
        onClick();
        await window.yieldToMainThread();
        trackLoadMoreButtonClicked();
    };

    return (
        <div className="d-flex justify-content-center mt-1x mb-3x mb-sm-6x">
            <Button
                onClick={handleLoadMoreClick}
                variant={ButtonVariant.Outlined}
                disabled={disabled}
            >
                <FormattedMessage defaultMessage="Mehr anzeigen" />
            </Button>
        </div>
    );
};

export { LoadMoreButton };
